import FilterBase from "./filterBase.js";

export default class Equalizer extends FilterBase {
    objectType = "EqualizerFilterItem";

    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }

    objectToClassValue(args = {}) {
        if (args.tooltip == null) {
            args.tooltip = "Applique un égaliseur à l'image, crée un effet de contraste et de saturation";
        }
        super.objectToClassValue(args);
    }

    static get Name() {
        return "Equalizer";
    }

    replaceChannel(cv, mat, channelIndex, newChannel) {
        try {
            // Vérifier si mixChannels et MatVector sont disponibles
            if (typeof cv.mixChannels !== 'function' || typeof cv.MatVector !== 'function') {
                throw new Error("cv.mixChannels ou cv.MatVector n'est pas disponible");
            }

            // Créer des MatVector pour les sources et destinations
            const srcVector = new cv.MatVector();
            const dstVector = new cv.MatVector();

            // Ajouter les matrices aux vecteurs
            srcVector.push_back(newChannel);
            dstVector.push_back(mat);

            // Définir le mapping des canaux [srcCanal, dstCanal]
            const fromTo = [0, channelIndex]; // Canal 0 de la source vers le canal spécifié de la destination

            // Remplacer le canal
            cv.mixChannels(srcVector, dstVector, fromTo);

            // Récupérer la matrice de destination
            mat = dstVector.get(0);

            // Nettoyer les vecteurs
            srcVector.delete();
            dstVector.delete();

            return mat;
        } catch (error) {
            console.error("Erreur avec mixChannels:", error);
            throw error;
        }
    }

    extractChannel(cv, mat, channelIndex) {
        try {

            // Vérifier si mixChannels est disponible
            if (typeof cv.mixChannels !== 'function') {
                throw new Error("cv.mixChannels n'est pas disponible");
            }

            let dst = new cv.Mat(mat.rows, mat.cols, cv.CV_8UC1);
            // Créer des MatVector pour les sources et destinations
            const srcVector = new cv.MatVector();
            const dstVector = new cv.MatVector();

            // Ajouter les matrices aux vecteurs
            srcVector.push_back(mat);
            dstVector.push_back(dst);

            // Définir le mapping des canaux [srcCanal, dstCanal]
            const fromTo = [channelIndex, 0];

            // Extraire le canal
            cv.mixChannels(srcVector, dstVector, fromTo);

            // Récupérer la matrice de destination
            dst = dstVector.get(0);

            // Nettoyer les vecteurs
            srcVector.delete();
            dstVector.delete();

            return dst;
        } catch (error) {
            console.error("Erreur avec mixChannels():", error);
            throw error;
        }
    }

    async filterAction(cv, cvImage) {
        try {

            // Convertir en Lab
            cv.cvtColor(cvImage, cvImage, cv.COLOR_RGB2Lab);

            // Extraire le canal L (luminance) - canal 0
            let lab = this.extractChannel(cv, cvImage, 0);

            // Appliquer CLAHE si disponible
            if (typeof cv.CLAHE === 'function') {
                let clahe = new cv.CLAHE(2.0, new cv.Size(8, 8));
                clahe.apply(lab, lab);
                clahe.delete();
            } else {
                // Fallback vers equalizeHist si CLAHE n'est pas disponible
                if (typeof cv.equalizeHist === 'function') {
                    cv.equalizeHist(lab, lab);
                }
            }

            // Remettre le canal L modifié dans l'image
            this.replaceChannel(cv, cvImage, 0, lab);

            // Convertir de Lab vers RGB
            cv.cvtColor(cvImage, cvImage, cv.COLOR_Lab2RGB);

            // Nettoyer la mémoire
            lab.delete();

            return cvImage;
        } catch (error) {
            console.error("Erreur dans le filtre equalizer:", error);
            // En cas d'erreur, retourner l'image originale
            return cvImage;
        }
    }
}